module.exports = __webpack_public_path__ + "static/media/step-2-of-2.d39384e7.png";